export default {
  // Page title
  'page.title': 'Chronomètre',

  // How to use
  'howto.title': 'Comment Utiliser',
  'howto.step1': 'Cliquez sur le bouton "Démarrer" pour lancer le chronomètre, format d\'affichage : minutes:secondes.centisecondes',
  'howto.step2': 'Cliquez sur "Pause" pour suspendre le chronométrage lorsque le chronomètre est en cours d\'exécution, cliquez à nouveau sur "Démarrer" pour continuer',
  'howto.step3': 'Cliquez sur le bouton "Réinitialiser" pour remettre le chronomètre à zéro et arrêter le chronométrage',
  'howto.step4': 'Le chronomètre prend en charge l\'affichage de précision à la milliseconde, adapté aux scénarios nécessitant un chronométrage précis',

  // User reviews
  'reviews.title': 'Avis des Utilisateurs',
  'reviews.michaelRunner': 'Outil d\'entraînement essentiel ! La précision à la milliseconde me permet d\'enregistrer avec précision chaque performance de sprint, opération simple et rapide.',
  'reviews.chefJohnson': 'Magie du minuteur de cuisine ! Faire sauter, faire bouillir des nouilles, cuire des œufs à la vapeur, tout nécessite un chronométrage précis, ce chronomètre m\'aide à préparer des plats parfaits.',
  'reviews.sarahStudent': 'Essentiel pour la simulation d\'examen ! Utilisé pour pratiquer le temps de réponse, l\'interface épurée ne distrait pas l\'attention, a amélioré l\'efficacité de réponse.',
  'reviews.coachWilliams': 'Excellent assistant pour les cours d\'entraînement ! L\'entraînement par intervalles et les planches nécessitent un chronométrage précis, les étudiants adorent.',
  'reviews.drAnderson': 'Le travail médical nécessite souvent un chronométrage précis, ce chronomètre est simple et fiable, un excellent assistant pour mon travail clinique.',

  // User names
  'user.michaelRunner': 'Michael Coureur',
  'user.chefJohnson': 'Chef Johnson',
  'user.sarahStudent': 'Sarah Étudiante',
  'user.coachWilliams': 'Coach Williams',
  'user.drAnderson': 'Dr. Anderson',

  // Keywords section
  'keywords.stopwatch': 'chronomètre minuteur chronométrage précis quelle heure est-il',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};